import dayjs from 'dayjs';
import { ThirdPartEnum } from 'Interfaces/ICompaniesConfig';
import {
  EnumBindingPeriod,
  EnumCycleAlignment,
  EnumProductSecurity,
  EnumProductVariant,
  EnumTempProductType,
  IFileAddViewModel,
} from 'Interfaces/IGlobalTypeConfig';
import { IProductViewModel } from 'Interfaces/IProductConfig';
import { IProductTypeViewModel } from 'pages/Billing/BillingConfig';
import { IBrandViewModel } from 'pages/Setup/setupConfig';
export interface CloudFactoryCompareProduct {
  companyId: string;
  name: string;
  description: string;
  sku: string;
  bindingPeriod: EnumBindingPeriod;
  paymentCycle: EnumBindingPeriod;
  unitPrice: number;
  costPrice: number;
  quantity: number;
  companyProductQty: number;
  commitmentEndDate: string;
}

export interface CloudFactoryAddProductViewModel {
  product: IProductViewModel;
  quantity: number;
  createdBy: string;
  companyId: string;
}
export interface CloudFactoryAddProductListViewModel {
  numberOfProducts: number;
  products: CloudFactoryAddProductViewModel[];
}
export interface CloudFactoryProductViewModel {
  companyId: string;
  product: IProductViewModel;
  quantity: number;
  companyProductQuantity: number;
}
export interface CloudFactoryProductListViewModel {
  numberOfCloudFactoryProducts: number;
  cloudFactoryProducts: CloudFactoryProductViewModel[];
}

export interface CloudFactoryEmployeeViewModel {
  name: string;
  companyId: string;
  creatorId: string;
  phone: string;
  email: string;
  departmentId: string | null;
  primaryContact: boolean;
  legacyId: number;
  thirdPartyId: string;
  thirdParty: ThirdPartEnum;
  productIds: string[];
  isEmailFoundInBluu: boolean;
  isNotEmailInCloudFactory: boolean;
}
export interface CloudFactoryEmployeeListViewModel {
  numberOfCloudFactoryEmployees: number;
  cloudFactoryEmployees: CloudFactoryEmployeeViewModel[];
}

export interface CloudFactoryResourceAddViewModel {
  name: string;
  creatorId: string;
  companyId: string;
  contactId: null | string;
  email: string;
  resourceTypeId: string | null; // For resources, this can be null
  departmentId: string | null;
  legacyId: number;
  thirdPartyId: string;
  thirdParty: ThirdPartEnum;
  isEmailFoundInBluu: boolean;
  isNotEmailInCloudFactory: boolean;
  productIds?: string[]; 
}
export interface CloudFactoryResourceAddListViewModel {
  numberOfCloudFactoryResources: number;
  cloudFactoryResources: CloudFactoryResourceAddViewModel[];
}
export interface IImportEmployeeAddViewModel {
  name: string;
  creatorId: string;
  companyId: string;
  phone: string;
  email: string;
  departmentId: string | null;
  primaryContact: boolean;
  legacyId: number;
  thirdPartyId: string;
  thirdParty: ThirdPartEnum;
  productIds: string[];
  isEmailFoundInBluu: boolean;
  isNotEmailInCloudFactory: boolean;
}
export interface IImportEmployeeAddListViewModel {
  cloudFactoryEmployees: IImportEmployeeAddViewModel[];
}
export interface ICloudFactoryEmployeeAddListViewModel {
  employees: IImportEmployeeAddViewModel[];
}
export interface IImportProductAddViewModel {
  name: string;
  companyId: string;
  comment: string | null;
  serialNumber: string | null;
  unitPrice: number;
  retailPrice: number;
  security: EnumProductSecurity;
  fileModel: IFileAddViewModel | null;
  tempType: EnumTempProductType | null;
  imageFile: string;
  productTypeId: string;
  EAN: string;
  brandId: string;
  quantity: number;
  paymentCycle: EnumBindingPeriod;
  cycleAlignment: EnumCycleAlignment;
  bindingPeriod: EnumBindingPeriod;
  productFeatureDataIds: string[];
  legacyId: number;
  thirdPartyId: string;
  thirdParty: number;
  purchaserId: string;
  productVariant: EnumProductVariant; // EnumProductVariant;
  isConsumable: boolean;
}
export interface IImportProductListViewModel {
  products: IImportProductAddViewModel[];
}

export const removeLastColonPart = (input: string): string => {
  const lastIndex = input.lastIndexOf(':');
  if (lastIndex === -1) {
    return input; // Returner input uendret hvis ingen kolon finnes
  }
  return input.substring(0, lastIndex);
};
